import Text from "../../../../../palette/Text";

function Seating(props) {

    const {text, color, seatColor, textColor} = props;

    return (
        <div className="seat">
            <div className="down" style={{background: seatColor}}>
                <Text size={6} text={text} weight={'bold'} color={textColor}/>
            </div>
            <div className="back-seat" style={{background: color}}/>
        </div>
    )
}

export default Seating